import { useEffect } from 'react';
import { useFetcher, useMatch } from 'react-router';

import { ClientOnly } from '@jane/bloom/components/clientOnly';
import { useBloomBasename } from '@jane/bloom/hooks/useBloomBasename';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import type { FooterTemplate } from '@jane/bloom/routes/api.footer/types';

import { ShadowFooter } from './footer/shadowFooter.client';
import { TemplatedFooter } from './footer/templatedFooter';

export function Footer() {
  const { menuFooter } = useRootLoaderData();
  const fetcher = useFetcher<FooterTemplate>({ key: 'footer-template' });
  const basename = useBloomBasename();
  const isCheckout = useMatch('/checkout');

  useEffect(() => {
    if (!fetcher.data && fetcher.state === 'idle' && !menuFooter?.enabled) {
      fetcher.load(`${basename}api/footer`);
    }
  }, [basename, fetcher, menuFooter?.enabled]);

  if (isCheckout) {
    return null;
  }

  if (menuFooter && menuFooter.enabled) {
    return <ClientOnly>{() => <TemplatedFooter {...menuFooter} />}</ClientOnly>;
  }

  if (fetcher.data) {
    return (
      <ClientOnly>
        {() => <ShadowFooter {...(fetcher.data as FooterTemplate)} />}
      </ClientOnly>
    );
  }

  return null;
}
